<script lang="ts">
  import { Accordion, AccordionItem, Col, Row } from "sveltestrap"
  import CategoryFilter from "./CategoryFilter.svelte"

  export let isMobile: boolean;

  export let selectedCategories;
  export let selectCategory;
  export let removeCategory;

  let filterOpen = false;
</script>

{#if isMobile}
  <div class="filter-mobile">
    <div class="filter-button" on:click={() => filterOpen = !filterOpen}>
      <img class="icon-small filter-icon" src="/icons/filter.svg" alt="placeholder"/>
    </div>
  </div>
  <div style={filterOpen ? '' : 'display: none'} class="filter-expand">
    <Row class="filter-expand-header">
      <Col>
        Clear all
        <img class="icon-small" src="/icons/x.svg" alt="placeholder"/>
      </Col>
      <Col class="text-end">
        <div on:click={() => filterOpen = !filterOpen}>
          Done
        </div>
      </Col>
    </Row>
    <Row class="filter-expand-body">
      <Accordion stayOpen>
        <AccordionItem header="Category" active>
          <CategoryFilter inlineButton="{false}" {selectedCategories} {selectCategory} {removeCategory} />
        </AccordionItem>
      </Accordion>
    </Row>
  </div>
{:else}
  <div class="filter-pc">
    <div class="filter-title">Filter</div>
    <Accordion stayOpen>
      <AccordionItem header="Category" active>
        <CategoryFilter inlineButton="{false}" {selectedCategories} {selectCategory} {removeCategory} />
      </AccordionItem>
    </Accordion>
  </div>
{/if}


